import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M8.8 2.4H1.6v.8h7.2v-.8zm.8.8h4.8v-.8H9.6v.8zM4.8 7.6H1.6v.8h3.2v-.8zm.8.8h8.8v-.8H5.6v.8zM7.2 12.8H1.6v.8h5.6v-.8zm.8.8h6.4v-.8H8v.8z" fill="#000" /><path fill="#000" d="M8 15.2v-4h.8v4zM9.6 4.8v-4h.8v4zM4 10V6h.8v4z" /></svg>;